import React, { forwardRef } from "react"
import clsx from "clsx"

import classes from "./Card.module.scss"

const Card = (props, ref) => {
  const {
    children,
    className,
    ...otherProps
  } = props

  return (
    <div
      ref={ref}
      className={clsx(
        classes["container"],
        className
      )}
      {...otherProps}
    >
      {children}
    </div>
  )
}

export default forwardRef(Card)